export default __webpack_public_path__ + "static/media/VHQ-ondark.1e7fbc17.png";